'use client';

import { apiFetch } from '@/lib/utils/api';
import { CerAdminsSection, type CerFormAdmin } from '@slims/ui/organisms';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { AddCerUser } from './add-cer-user';

/**
 * Amministratori di una CER, nel suo dettaglio (solo superadmin). Prima si
 * gestivano da una pagina a parte aperta dalla matita (INB-374).
 */
export function CerAdmins({ cerId }: { cerId: string }) {
	const [admins, setAdmins] = useState<CerFormAdmin[]>([]);
	const [pendingRemove, setPendingRemove] = useState<CerFormAdmin | null>(null);

	const loadAdmins = useCallback(async () => {
		const res = await apiFetch(`/api/admin/cers/${cerId}/users`);
		if (!res.ok) return;
		const users = (await res.json()) as (CerFormAdmin & { role: string })[];
		setAdmins(users.filter((u) => u.role === 'admin'));
	}, [cerId]);

	useEffect(() => {
		void loadAdmins();
	}, [loadAdmins]);

	async function confirmRemove() {
		if (!pendingRemove) return;
		const res = await apiFetch(`/api/admin/cers/${cerId}/users/${pendingRemove.id}`, {
			method: 'DELETE',
		});
		if (res.ok) {
			setAdmins((prev) => prev.filter((a) => a.id !== pendingRemove.id));
			toast.success('Amministratore rimosso');
		} else {
			toast.error('Errore nella rimozione');
		}
		setPendingRemove(null);
	}

	return (
		<CerAdminsSection
			admins={admins}
			addAdmin={
				<AddCerUser
					basePath={`/api/admin/cers/${cerId}`}
					role="admin"
					roleLabel="amministratore"
					onAdded={() => void loadAdmins()}
				/>
			}
			pendingRemove={pendingRemove}
			onRemove={setPendingRemove}
			onConfirmRemove={() => void confirmRemove()}
			onCancelRemove={() => setPendingRemove(null)}
		/>
	);
}
